import { datadogLogs } from '@datadog/browser-logs';
import type { ILogTransport, LogLevelType, ILogContext } from './logger';
import { ENV } from '@user-portal/helpers';

export class ConsoleTransport implements ILogTransport {
  private readonly colors = {
    debug: '\x1b[90m', // Gray
    info: '\x1b[36m', // Cyan
    warn: '\x1b[33m', // Yellow
    error: '\x1b[31m', // Red
    reset: '\x1b[0m', // Reset
  };

  log(level: LogLevelType, message: string, context?: ILogContext) {
    const color = this.colors[level];
    const reset = this.colors.reset;
    const coloredMessage = `${color}[${level.toUpperCase()}]${reset} ${message}`;

    console[level](coloredMessage, context || '');
  }
}

export class DataDogTransport implements ILogTransport {
  constructor(config: { clientToken: string; serviceName: string; version?: string; env: ENV }) {
    datadogLogs.init({
      clientToken: config.clientToken,
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      env: config.env,
      service: config.serviceName,
      version: config.version || '1.0.0',
    });
  }

  log(level: LogLevelType, message: string, context?: ILogContext) {
    datadogLogs.logger[level](message, context);
  }
}
